import { Component } from '@lisergia/core'
import { MathUtils } from '@lisergia/utilities'

export default class Reveal extends Component {
  declare classes: {
    active: string
  }

  declare element: HTMLElement

  spriteElement = document.createElement('div')
  currentIndex = 0
  length = 30
  frameWidthRem = 60.3 // 603px / 10
  frameHeightRem = 67.4 // 674px / 10

  constructor({ element }: { element: HTMLElement }) {
    super({
      element,
    })

    this.setupSprite()
    this.preload()
  }

  setupSprite() {
    this.spriteElement.classList.add('gameplay__mouse__image')
    this.spriteElement.style.width = `${this.frameWidthRem}rem`
    this.spriteElement.style.height = `${this.frameHeightRem}rem`
    this.spriteElement.style.position = 'relative'
    this.spriteElement.style.backgroundImage = `url(${window.VARIABLES.THEME}/images/mouse-sprite.png)`
    this.spriteElement.style.backgroundSize = `${this.frameWidthRem * this.length}rem ${this.frameHeightRem}rem`
    this.spriteElement.style.backgroundRepeat = 'no-repeat'
    this.spriteElement.style.backgroundPosition = '0 0'

    this.element.appendChild(this.spriteElement)
  }

  preload() {
    const img = new Image()
    img.src = `${window.VARIABLES.THEME}/images/mouse-sprite.png`
  }

  setFrame(index: number) {
    const clampedIndex = Math.max(0, Math.min(Math.round(index), this.length - 1))

    if (clampedIndex === this.currentIndex) return

    this.currentIndex = clampedIndex
    const xPos = -(clampedIndex * this.frameWidthRem)
    this.spriteElement.style.backgroundPosition = `${xPos}rem 0`
  }

  onMouseMove({ clientX }: MouseEvent) {
    const x = MathUtils.map(clientX, 0, window.innerWidth, 0, this.length - 1)

    this.setFrame(x)
  }

  addEventListeners() {
    window.addEventListener('mousemove', this.onMouseMove)
  }

  removeEventListeners() {
    window.removeEventListener('mousemove', this.onMouseMove)
  }
}
